<template>
  <div class="basic-information">
    <h3 class="basic-information__title">Основная информация</h3>

    <div class="basic-information__section">
      <div class="basic-information__section-title" style="margin-bottom: 16px;">Описание вакансии</div>
      <div class="first-info">
        <div>
          <VCustomInput placeholder="Название вакансии*" :error="v$.vacancyName.$error"
                        v-model="form.vacancyName" name="vacancyName" id="vacancyName" ref="vacancyName"
                        class="basic-information__inp vacancyName"/>
          <p class="basic-information__inp-error" v-if="v$.vacancyName.$error">Заполните обязательное поле</p>
        </div>

        <div style="position:relative;">
          <VCustomInput placeholder="Профессия*" :error="v$.speciality.$error || searchNoResul"
                        v-model="form.specialityName" id="speciality" @input="debouncedSearchSpecialties"
                        class="basic-information__inp"/>
          <p class="basic-information__inp-error" v-if="form.specialityName && searchNoResul">Такой
            специальности нет
            в базе</p>
          <p class="basic-information__inp-error"
             v-if="v$.speciality.$error && (!form.specialityName && !searchNoResul)">Заполните
            обязательное поле</p>

          <div class="basic-information__section-search-results"
               v-if="form.specialityName && showSelectSpeciality && specialtiesList.length">
            <div class="basic-information__section-search-result" v-for="item in specialtiesList"
                 :key="item.id" :class="{
                        'basic-information__section-search-result_active':
                            form.speciality === item.id,
                    }" @click="selectSpeciality(item)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="basic-information__section">
      <div class="basic-information__section-title">Расскажите о вакансии</div>
      <p class="basic-information__section-subtitle">Не более 2000 символов</p>

      <div class="basic-information__section-form">
        <VEditor placeholder="Расскажите о вакансии*" :error="v$.description.$error" v-model="form.description"
                 id="description"
                 class="basic-information__editor"/>
        <p class="basic-information__inp-error" v-if="v$.description.$error">Заполните обязательное поле</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import useVuelidate from "@vuelidate/core";
import specialties from "@/api/specialties"
import regions from "@/api/regions"
import {useRoute} from "vue-router";
import VSegmentedControl from "../../UI/VSegmentedControl/index.vue";
import {DatePicker} from 'v-calendar';
import 'v-calendar/dist/style.css';
import {debounce} from "@/services/helpers"
import common from "@/api/common";

const props = defineProps({
  modelValue: Object,
  workingConditions: Object,
  salaryFromError: Boolean,
  integration: Boolean
});

const route = useRoute();

const emit = defineEmits(["update:modelValue"]);


const form = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});


const requiredField = (val) => {
  if (route.meta.type === 'vacancy' || route.params.templateId) {
    return !!val
  }
  if (route.meta.type === 'template') {
    return true
  }
}

const rules = computed(() => ({
  vacancyName: {requiredField},
  speciality: {requiredField},
  description: {requiredField},
}));
const v$ = useVuelidate(rules, form);

const showSelectSpeciality = ref(false)
const showSelectRegion = ref(false)


const search = ref("");
const searchNoResul = ref(false);

const specialtiesList = ref([]);

const searchSpecialties = async () => {
  setTimeout(() => {
    showSelectSpeciality.value = true
  }, 150)

  if (!form.value.specialityName?.length) {
    form.value.speciality = ''
  }

  try {
    specialtiesList.value = await specialties.getSearchSpecialties({
      search: form.value.specialityName,
    });

    searchNoResul.value = !specialtiesList.value.length ? true : false

  } catch (error) {
  }
};

const debouncedSearchSpecialties = debounce(() => searchSpecialties(), 400)

const selectSpeciality = (option) => {
  form.value.speciality = option.id
  form.value.specialityName = option.name
  showSelectSpeciality.value = false
};

onMounted(() => {
  document.addEventListener('click', (e) => {
    const className = '.basic-information__section-search-results'
    if (!e.target.closest(className) || !e.target.className === className) {
      showSelectSpeciality.value = false
      showSelectRegion.value = false
    }
  })
});
</script>

<style scoped lang="scss">
.basic-information {
  width: 100%;
  padding: 24px 24px 29px 24px;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 2px 2px 8px 0px #0000000A;

  .first-info {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 16px;
  }

  &__date-inp-wrapper {
    width: 100%;
    height: 48px;
    padding: 0 16px;
    border-radius: 8px;
    background-color: $light;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &_disabled {
      position: relative;
      opacity: 0.3;
      user-select: none;

      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 4;
      }
    }

    &_error {
      border: 1px solid #DD4646;
    }
  }

  &__date-inp {
    width: 100%;
    height: 100%;
    font-size: 14px;
    background-color: transparent;

    &::placeholder {
      color: $dark-blue;
    }

    &_disabled {
      &::placeholder {
        opacity: .3;
      }
    }
  }

  &__date-inp-wrapper_disabled &__date-inp {
    opacity: 0.3;
    cursor: no-drop;
    user-select: none;

    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 4;
    }
  }

  &__date-inp-error {
    margin-top: 4px;
    font-size: 14px;
    color: #DD4646;
  }

  &__title {
    width: 100%;
    padding-bottom: 20px;
    font-size: 20px;
    font-weight: 500;
    border-bottom: 1px solid $light-gray-1;
  }

  &__section {
    margin-top: 20px;
  }

  &__section-title {
    font-size: 16px;
    font-weight: 500;
  }

  &__section-subtitle {
    margin-top: 4px;
    color: $gray;
    font-size: 14px;
  }

  &__section-form {
    &:not(:first-child) {
      margin-top: 16px;
    }
  }

  &__section-form-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__section-form-title {
    font-size: 16px;
    font-weight: 500;
  }

  &__section-form-segment {
    height: 40px;
    border-radius: 8px;

    &::v-deep(.v-filtration__filter) {
      width: 158px;
      font-weight: 400;
      border-radius: 4px;
    }
  }

  &__section-group {
    margin-top: -16px;
    margin-left: -16px;
    display: flex;
    flex-wrap: wrap;

    &:not(:first-child) {
      margin-top: 0;
    }
  }

  &__select-wrapper {
    margin-top: 16px;
  }

  &__small-select-wrapper {
    width: calc(50% - 16px);
    margin-top: 16px;
    margin-left: 16px;
  }

  &__small-select {
    width: 100%;

    &::v-deep(.v-select__header-arrow) {
      margin-right: 8px;
    }
  }

  &__inp-date {
    position: relative;

    &_disabled {
      opacity: 0.3;
      cursor: no-drop;
      user-select: none;

      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 4;
      }
    }
  }

  &__big-inp {
    width: 100%;
    margin-top: 16px;
  }

  &__section-row {
    width: 100%;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;

    &_salary {
      margin-top: 12px;
    }
  }

  &__inp-wrapper {
    width: calc(50% - 8px);
  }

  &__small-inp-wrapper {
    position: relative;
    width: calc(50% - 8px);
    font-size: 14px;

    & > .salary-input__input {
      font-size: 14px;
    }
  }

  &__small-inp {
    width: calc(50% - 8px);
  }

  &__small-inp-salary {
    width: 100%;
  }

  &__section-search {
    position: relative;
    width: calc(50% - 8px);
  }

  &__section-search-results {
    position: absolute;
    top: 56px;
    left: 0;
    width: 100%;
    max-height: 256px;
    padding: 8px;
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid $light-gray-1;
    box-shadow: 2px 4px 24px 0 #0000001F;
    z-index: 9;
    overflow: auto;
  }

  &__section-search-result {
    width: 100%;
    height: 40px;
    border-radius: 8px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    overflow: hidden;

    &:hover {
      background-color: $light-gray-1;
      color: $dark;
    }

  }

  &__inp {
    width: 100%;
  }

  &__inp-error {
    margin-top: 4px;
    font-size: 14px;
    color: $red;
  }

  &__editor {

    margin-top: 16px;

    &::v-deep(.v-editor__editor) {
      height: 240px;
    }
  }

  &__checkbox {
    margin-top: 13px;
    display: flex;
    align-items: center;
  }

  &__checkbox-label {
    margin-right: 17px;
    padding-bottom: 4px;
    font-size: 14px;
  }
}

.half-width {
  max-width: calc(50% - 8px);
}

.salary-input {
  position: relative;
  font-size: 14px;

  &__input {

    &[data-value-length='1'] {
      :deep(.v-input__input_focus) {
        margin-left: 4px;
      }
    }

    &[data-value-length='2'] {
      :deep(.v-input__input_focus) {
        margin-left: 8px;
      }
    }

    &[data-value-length='3'] {
      :deep(.v-input__input_focus) {
        margin-left: 12px;
      }
    }

    &[data-value-length='4'] {
      :deep(.v-input__input_focus) {
        margin-left: 16px;
      }
    }

    :deep(.v-input__input_focus) {
      color: transparent;
      background-color: transparent;
      position: relative;
      z-index: +1;
      caret-color: #000;

      &::placeholder {
        opacity: 0;
      }
    }

  }

  &__span {
    position: absolute;
    left: 17px;
    top: 24px;
    font-size: inherit;
    color: inherit;
  }
}
/* Стиль для выбранной даты */
:deep(.vc-highlight) {
  background-color: $primary-main !important;
}

/* Стиль для ховера на любой день */
:deep(.vc-day-content:hover) {
  background-color: $primary-hover !important;
}
</style>
